import React, { useState, useEffect } from "react";
import { colors } from "../../../themes/Colors";
import BaseButtonsIcon from "../base-buttons-icon/BaseButtonsIcon";
import BaseButtons from "../base-buttons/BaseButtons";
import SearchBar from "../search-bar/SearchBar";

const ScreenDisplayHeaderActions = ({
  title,
  iconRight1,
  iconRight2,
  iconRight1Height,
  iconRight1Width,
  iconRight2Height,
  iconRight2Width,
  iconRight1Change,
  iconRight2Change,
  products,
  marginBottom,
  selected,
  onListClick,
  onBlockClick,
  search,
  onSearchChange,
  onAddProductClick,
  user,
  vehicles,
  onManageClick,
  onSeriesClick,
  originalDataArray,
  searchArray,
  setSearchArray,
}) => {
  const [hover, setHover] = useState("");
  return (
    <div
      style={{
        height: 25,
        width: "100%",
        display: "flex",
        alignItems: "center",
        marginBottom: marginBottom,
        marginTop: 15,
      }}
    >
      <div
        style={{
          fontSize: 18,
          color: colors.secondaryDarkBlue,
          fontWeight: "bold",
          //   marginBottom: 10,
          marginLeft: 20,
          width: 200,
        }}
      >
        {title}
      </div>

      <div style={{ flex: 0.5 }}></div>
      <SearchBar
        originalSearchArray={originalDataArray}
        arrayToSearchInput={searchArray}
        setResultsArray={setSearchArray}
      />
      <div style={{ flex: 0.5 }}></div>
      {products ? (
        <div
          style={{
            marginRight: 20,
            display: "flex",
            marginTop: 5,
            WebkitBoxShadow: "-1px 5px 5px -1px #00000070",
            borderRadius: 8,
          }}
        >
          <div
            onMouseOut={() => setHover("")}
            onMouseOver={() => setHover("block")}
            onClick={onBlockClick}
            style={{
              height: 40,
              width: 50,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor:
                hover === "block"
                  ? colors.greenDark
                  : selected === "block"
                  ? colors.greenLight
                  : "#00000030",
              borderTopLeftRadius: 8,
              borderBottomLeftRadius: 8,
              transition: "all 0.5s",
            }}
          >
            {hover === "block" ? (
              <img
                alt="icon"
                src={iconRight1}
                style={{ height: iconRight1Height, width: iconRight1Width }}
              />
            ) : selected === "block" ? (
              <img
                alt="icon"
                src={iconRight1}
                style={{ height: iconRight1Height, width: iconRight1Width }}
              />
            ) : (
              <img
                alt="icon"
                src={iconRight1Change}
                style={{ height: iconRight1Height, width: iconRight1Width }}
              />
            )}
          </div>

          <div
            onClick={onListClick}
            onMouseOut={() => setHover("")}
            onMouseOver={() => setHover("list")}
            style={{
              height: 40,
              width: 50,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor:
                hover === "list"
                  ? colors.greenDark
                  : selected === "list"
                  ? colors.greenLight
                  : "#00000030",
              borderTopRightRadius: 8,
              borderBottomRightRadius: 8,
              // WebkitBoxShadow: "1px 5px 5px -1px #00000070",
            }}
          >
            {hover === "list" ? (
              <img
                alt="icon"
                src={iconRight2}
                style={{ height: iconRight2Height, width: iconRight2Width }}
              />
            ) : selected === "list" ? (
              <img
                alt="icon"
                src={iconRight2}
                style={{ height: iconRight2Height, width: iconRight2Width }}
              />
            ) : (
              <img
                alt="icon"
                src={iconRight2Change}
                style={{ height: iconRight2Height, width: iconRight2Width }}
              />
            )}
          </div>
        </div>
      ) : null}
      {user ? (
        <div style={{ marginRight: 20, marginTop: 5 }}>
          <BaseButtons
            label={"+ INVITE USER"}
            height={40}
            backgroundColor={colors.greenLight}
            borderRadius={8}
            width={135}
            onClick={onAddProductClick}
          />
        </div>
      ) : null}
      {user ? null : (
        <div style={{ marginRight: 20, marginTop: 5 }}>
          <BaseButtons
            label={"+ ADD VEHICLE"}
            height={40}
            backgroundColor={colors.greenLight}
            borderRadius={8}
            width={135}
            onClick={onAddProductClick}
          />
        </div>
      )}
    </div>
  );
};

export default ScreenDisplayHeaderActions;
